import BaseModel from "./BaseModel";
import moment from "moment";

export const DEFAULT_AUTOFILL_PLATFORMS = [
    {
        area: "Booking.vinpearl.com",
        platform: "WEB_PC",
        feature: "HOTEL",
        isEnabled: true
    },
    {
        area: "Booking.vinpearl.com",
        platform: "WEB_MOBILE",
        feature: "HOTEL",
        isEnabled: true
    },
    {
        area: "Booking.vinwonders.com",
        platform: "WEB_PC",
        feature: "BOOKING_VINWONDER",
        isEnabled: false
    },
    {
        area: "Booking.vinwonders.com",
        platform: "WEB_MOBILE",
        feature: "BOOKING_VINWONDER",
        isEnabled: true
    }
];

export const getAutoFillPlatformKey = ({ area, platform, feature }) => `${area}_${platform}_${feature}`;

export const normalizeAutoFillPlatforms = (platforms = [], useCreateDefaults = false) => {
    return DEFAULT_AUTOFILL_PLATFORMS.map(defaultPlatform => {
        const platformData = platforms.find(item => getAutoFillPlatformKey(item) === getAutoFillPlatformKey(defaultPlatform));
        return {
            ...defaultPlatform,
            ...platformData,
            isEnabled: typeof platformData?.isEnabled === "boolean"
                ? platformData.isEnabled
                : useCreateDefaults && defaultPlatform.isEnabled
        };
    });
};

const migrateLegacyMyVpPlatformToProductTypes = (productTypes = [], platforms = []) => {
    const hasMyVpProductType = productTypes.includes('APP_MYVP');
    const hasLegacyMyVpPlatform = platforms.some(item => item?.platform === 'APP_MYVP' && item?.isEnabled);

    if (hasMyVpProductType || !hasLegacyMyVpPlatform) {
        return productTypes;
    }

    return [...productTypes, 'APP_MYVP'];
};

export default class AutoFill extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.campaignId = data.campaignId || this.translate.campaignId || undefined;
        this.campaignName = data.campaignName || this.translate.campaignName || undefined;
        this.promotionCode = data.promotionCode || this.translate.promotionCode || [];
        this.promotionCodeId = data.promotionCodeId || this.translate.promotionCodeId || undefined;
        this.order = data.order || this.translate.order || undefined;
        this.startDate = data.startDate || this.translate.startDate || undefined;
        this.endDate = data.endDate || this.translate.endDate || undefined;
        this.dayOfWeek = Array.isArray(data.dayOfWeek) === true ? this.parseDayOfWeekFromArrToObj(data.dayOfWeek || []) : data.dayOfWeek;
        // this.dayOfWeek = data.dayOfWeek || this.translate.dayOfWeek || [];
        this.memberShipTypes = data.memberShipTypes || this.translate.memberShipTypes || [];
        const platforms = data.platforms || this.translate.platforms || [];
        const productTypes = data.productTypes || this.translate.productTypes || [];
        this.productTypes = migrateLegacyMyVpPlatformToProductTypes(productTypes, platforms);
        const isCreateMode = !data.id;
        this.platforms = normalizeAutoFillPlatforms(platforms, isCreateMode);
        this.isActive = typeof data.isActive == "boolean" ? data.isActive : true;
    }

    parseDayOfWeekFromArrToObj(arrDayOfWeek) {
        let result = {};
        if (arrDayOfWeek && arrDayOfWeek.length > 0) {
            (moment.localeData('en').weekdays() || []).map((day, index) => {
                const dayKey = day.toLowerCase();
                const isAllowAdd = arrDayOfWeek.filter(item => { return item === index });
                result = isAllowAdd && isAllowAdd.length > 0 ? Object.assign(result, { [`${dayKey}`]: true }) : result;
            })
        }
        return result;
    }

    parseDayOfWeek(data) {
        let result = [];
        if (data && Object.keys(data).length > 0) {
            (moment.localeData('en').weekdays() || []).map((day, index) => {
                const dayKey = day.toLowerCase();
                if (dayKey && data[dayKey]) {
                    result.push(index);
                }
            })
        }
        return result ? result.sort() : result;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            campaignId: this.campaignId,
            campaignName: this.campaignName,
            promotionCodes: this.promotionCodes,
            promotionCodeId: this.promotionCodeId,
            order: this.order,
            startDate: this.startDate && this.startDate.utcOffset(0, true).format(),
            endDate: this.endDate && this.endDate.utcOffset(0, true).format(),
            dayOfWeek: this.parseDayOfWeek(this.dayOfWeek),
            memberShipTypes: this.memberShipTypes,
            productTypes: this.productTypes,
            platforms: normalizeAutoFillPlatforms(this.platforms, false),
            isActive: this.isActive,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id
            }
        }
        return result;
    }
}
